import { makePostRequest } from 'owa-ows-gateway';
import { SharingLinkInfoResponse } from '../types/SharingLinkInfoResponse';

const GET_SHARING_LINK_INFO_URL = 'ows/api/beta/sharinglink/info';

export function getSharingLinkInfo(link: string): Promise<SharingLinkInfoResponse>;
export function getSharingLinkInfo(link: string, returnRawResponse: true): Promise<Response>;
export function getSharingLinkInfo(
    link: string,
    returnRawResponse: false
): Promise<SharingLinkInfoResponse>;
export async function getSharingLinkInfo(
    link: string,
    returnRawResponse: boolean = false
): Promise<SharingLinkInfoResponse | Response> {
    return await makePostRequest(
        GET_SHARING_LINK_INFO_URL,
        { url: link },
        undefined /* correlationId */,
        returnRawResponse
    );
}
